import { customTextBlock, heading,
  paragraph,
  button } from "../../../text/nodes"
import { getFont } from "app/regions/blocks/shared/fonts"
import { LargeCTA as LargeCTAEditor } from "./large-cta"
import { LargeCTASettings } from "./large-cta-settings"
import LargeCTAPreview from "./large-cta-preview.png"

export const LargeCTA = {
  name: "LargeCTA",
  label: "large call to action with background",
  EditorComponent: LargeCTAEditor,
  SettingsComponent: LargeCTASettings,
  image: LargeCTAPreview,
  defaultProperties: {
    backgroundColor: "#e3e3e3",
    contentBackgroundColor: "#FFFFFF",
    headingColor: "#2c2c2c",
    textColor: "#4d4d4d",
    image: "",
    horizontalPadding: 32,
    verticalPadding: 32,
    marginTop: 24,
    marginBottom: 24,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#e3e3e3",
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderLeftWidth: 0,
    borderBottomWidth: 0,
    headingFontFamily: getFont("Georgia"),
    headingFontWeight: 500,
    textFontFamily: getFont("System Font"),
    textFontWeight: 400
  },
  defaultChildren: [
    customTextBlock([
      heading("two", "Chicken & Squash Curry", { alignment: "center" }),
      paragraph(
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc interdum, elit id molestie laoreet, arcu quam molestie orci.",
        { alignment: "center" }
      ),
      button("Send me the recipe", { roundedCornerOption: "none" })
    ])
  ]
}
